export const PAYPAL_MERCHANT_ISSUE_LOCKED_OR_CLOSED = 'PAYEE_ACCOUNT_LOCKED_OR_CLOSED';
export const PAYPAL_MERCHANT_ISSUE_NOT_READY = 'PAYPAL_MERCHANT_NOT_READY';
export const PAYPAL_MERCHANT_ISSUE_LOOKUP_FAILED = 'PAYPAL_MERCHANT_STATUS_LOOKUP_FAILED';

export const getPaypalMerchantStatusIssue = value => {
  if (!value || typeof value !== 'object') {
    return null;
  }

  if (typeof value.issue === 'string' && value.issue.trim()) {
    return value.issue.trim();
  }

  const publicDataIssue = value?.attributes?.profile?.publicData?.paypalMerchantStatusIssue;
  return typeof publicDataIssue === 'string' && publicDataIssue.trim()
    ? publicDataIssue.trim()
    : null;
};

export const canPayPalMerchantAcceptPayments = status => {
  if (!status || typeof status !== 'object') {
    return null;
  }

  if (typeof status.canAcceptPayments === 'boolean') {
    return status.canAcceptPayments;
  }

  const issue = getPaypalMerchantStatusIssue(status);
  if (issue) {
    return false;
  }

  const paymentsReceivable = status?.payments_receivable ?? status?.paymentsReceivable ?? null;
  const primaryEmailConfirmed =
    status?.primary_email_confirmed ?? status?.primaryEmailConfirmed ?? null;

  if (paymentsReceivable === false || primaryEmailConfirmed === false) {
    return false;
  }

  const merchantId = status?.merchant_id || status?.merchantId || null;
  return merchantId ? true : null;
};

export const isPayPalMerchantUnavailable = status => {
  return canPayPalMerchantAcceptPayments(status) === false;
};

export const getPayPalMerchantBannerContent = ({ currentUser, merchantStatus }) => {
  const liveMerchantAvailability = canPayPalMerchantAcceptPayments(merchantStatus);
  const issue =
    liveMerchantAvailability === true
      ? null
      : liveMerchantAvailability === false
      ? getPaypalMerchantStatusIssue(merchantStatus)
      : getPaypalMerchantStatusIssue(merchantStatus) || getPaypalMerchantStatusIssue(currentUser);
  const isLockedOrClosed = issue === PAYPAL_MERCHANT_ISSUE_LOCKED_OR_CLOSED;

  return {
    messageId: isLockedOrClosed
      ? 'Topbar.paypalLockedBanner'
      : 'Topbar.paypalUnavailableBanner',
    defaultMessage: isLockedOrClosed
      ? 'Your linked PayPal account is locked or closed. Reconnect PayPal to show PayPal at checkout again.'
      : 'Your linked PayPal account cannot currently receive payments. Reconnect PayPal to show PayPal at checkout again.',
  };
};

export const shouldShowPayPalMerchantBanner = ({ currentUser, merchantStatus }) => {
  const merchantId = currentUser?.attributes?.profile?.publicData?.merchantId || null;
  if (!merchantId) {
    return false;
  }

  const liveMerchantAvailability = canPayPalMerchantAcceptPayments(merchantStatus);
  if (liveMerchantAvailability === true) {
    return false;
  }

  if (liveMerchantAvailability === false) {
    return true;
  }

  return Boolean(getPaypalMerchantStatusIssue(currentUser));
};
